import { TypedThunk } from 'reducers'
import { v4 as uuidv4 } from 'uuid'
import {
  CART_CREATE_BUSINESS_INFO,
  CART_WIPE_ALL_BUSINESS_INFO,
  CART_ADD_ITEM,
  CART_REMOVE_ITEM,
  CART_INCREASE_QUANTITY,
  CART_DECREASE_QUANTITY,
  SET_CURRENCY,
  RESET_TO_INITIAL_STATE,
  SET_STRIPE_ORDER_STATUS,
  RESET_STRIPE_ORDER_STATUS,
  CART_REMOVE_ALL_ITEMS
} from '../constants'
import { setDeliverDetails } from './orderActions'

export const addingHandlerAction =
  (businessId, item): TypedThunk =>
  (dispatch, getState) => {
    const cartData = getState().cart

    if (cartData.businessId !== '') {
      if (cartData.businessId === businessId) {
        if (cartData.usesSingleItemCheckout) {
          dispatch(removeAllItemsInCart())
          dispatch(addItemToCart(item))

          return
        }

        const businessItem = cartData.items.find(
          (x) => x.comparisonId === item.comparisonId
        )

        if (businessItem) {
          dispatch(increaseQuantity(businessItem.id, item.quantity))
        } else {
          dispatch(addItemToCart(item))
        }
      } else {
        throw 'Business Changed'
      }
    } else {
      dispatch(createBusinessInfo(businessId))
      dispatch(addItemToCart(item))
    }
  }

export const createBusinessInfo = (businessId) => (dispatch, getState) => {
  const { location_id } = getState().restaurantDetails.data

  dispatch({
    type: CART_CREATE_BUSINESS_INFO,
    payload: { businessId, regionId: location_id }
  })
}

export const removeAllItemsInCart = () => ({
  type: CART_REMOVE_ALL_ITEMS
})

export const removeBusinessInfo = () => (dispatch, getState) => {
  dispatch({ type: CART_WIPE_ALL_BUSINESS_INFO })
  dispatch(setDeliverDetails({ deliveryType: null }))
}

export const addItemToCart =
  (item): TypedThunk =>
  (dispatch, getState) => {
    const {
      delivery,
      pickup,
      business_type_id,
      name,
      id,
      country_iso_code,
      supports_cash_on_delivery,
      supports_bitcoin,
      supports_mmg,
      accepts_credit_card,
      uses_two_destinations,
      currency,
      pickup_fee,
      merchant_id,
      service_fees,
      taxes,
      uses_single_item_checkout,
      is_bill_payment
    } = getState().restaurantDetails.data!
    const { items } = getState().cart

    const customizedItem = { ...item, id: uuidv4() } //  new UUID generated for new item to list

    let subTotal = 0

    const allItems = [...items, customizedItem]

    allItems?.forEach((item) => {
      subTotal += item.cost * item.quantity
    })

    dispatch({
      type: CART_ADD_ITEM,
      payload: {
        items: [...items, customizedItem],
        delivery,
        pickup,
        businessTypeId: business_type_id,
        businessName: name,
        businessId: id,
        isoCode: country_iso_code,
        supportsCashOnDelivery: supports_cash_on_delivery,
        supportsBitcoin: supports_bitcoin,
        supportsMmg: supports_mmg,
        supportsCreditCard: accepts_credit_card,
        usesTwoDestinations: uses_two_destinations,
        pickupFee: pickup_fee,
        merchantId: merchant_id,
        serviceFees: service_fees,
        currency,
        taxes,
        subTotal: +subTotal.toFixed(2),
        usesSingleItemCheckout: uses_single_item_checkout,
        usesBillingPayment: is_bill_payment
      }
    })
  }

export const removeItemFromCart = (id) => (dispatch, getState) => {
  const cartData = getState().cart

  const itemIndex = cartData.items.findIndex((x) => x.id === id)

  dispatch({ type: CART_REMOVE_ITEM, payload: itemIndex })

  if (cartData.items.length - 1 === 0) {
    dispatch(removeBusinessInfo())
  }
}

export const increaseQuantity =
  (id, quantity = 1) =>
  (dispatch, getState) => {
    const cartData = getState().cart
    const itemIndex = cartData.items.findIndex((x) => x.id === id)

    if (itemIndex !== -1) {
      dispatch({
        type: CART_INCREASE_QUANTITY,
        payload: { index: itemIndex, quantity }
      })
    }
  }

export const decreaseQuantity = (id) => (dispatch, getState) => {
  const cartData = getState().cart
  const indexItem = cartData.items.findIndex((x) => x.id === id)

  if (indexItem !== -1) {
    dispatch({ type: CART_DECREASE_QUANTITY, payload: indexItem })
  }
}

export const setCurrency = () => (dispatch, getState) => {
  const { currency } = getState().restaurantDetails.data

  dispatch({
    type: SET_CURRENCY,
    payload: currency
  })
}

export const setStripeOrderStatus = (value) => (dispatch, getState) => {
  dispatch({
    type: SET_STRIPE_ORDER_STATUS,
    payload: value
  })
}

export const resetStripeOrderStatus = () => (dispatch, getState) => {
  dispatch({
    type: RESET_STRIPE_ORDER_STATUS
  })
}

export const resetOrderAndCart = () => (dispatch, getState) => {
  const serviceDeliveryOptions = getState().serviceDeliveryOptions

  dispatch({
    type: CART_WIPE_ALL_BUSINESS_INFO
  })

  dispatch({
    type: RESET_TO_INITIAL_STATE,
    payload: serviceDeliveryOptions
  })
}
